import { Typography, Grid } from "@mui/material";
import { ChangeEvent, FC, useMemo, useState } from "react";
import { clubStakingColumns } from "../../common/constants/clubs.constants";
import { StakingStatus } from "../../common/enums/club.enums";
import {
  IClubStakings,
  IStakingTableItems,
} from "../../common/interfaces/club.interface";
import useFuse from "../../hooks/useFuse";
import { getStakeStatus } from "../../utils/helpers";
import AppCard from "../cards/AppCard";
import { DataTable } from "../tables/DataTable";

const ClubStaking: FC<{ stakings: IClubStakings }> = ({ stakings }) => {
  const [page, setPage] = useState<number>(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [tableItems, setTableItems] = useState<IStakingTableItems[]>(
    stakings.stakingAccounts.map((item) => {
      return {
        name: item.name,
        rasiedAmount: item.rasiedAmount,
        stakingStatus: getStakeStatus(item.stakingStatus),
      };
    })
  );

  const handlePageChange = (event, newPage: number) => {
    setPage(newPage);
  };

  const onRowsPerPageChange = (event: ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const options = {
    includeScore: true,
    keys: clubStakingColumns.map((col) => col.id),
  };

  const filteredList: IStakingTableItems[] = useFuse(tableItems, "", options);

  const totalActiveStakings = useMemo(() => {
    return stakings.stakingAccounts.filter(
      (item) => item.stakingStatus === StakingStatus.InProgress
    ).length;
  }, []);

  return (
    <div>
      <Typography variant="subtitle1" my={1}>
        Stakings
      </Typography>
      <Grid
        container
        spacing={{ xs: 1, md: 2, sm: 2 }}
        columns={{ xs: 4, sm: 8, md: 10 }}
      >
        <Grid item xs={12} sm={12} md={5}>
          <AppCard
            label={"Total staked amount"}
            value={stakings.totalStakedAmount.toString()}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={5}>
          <AppCard
            label={"Total active stakings"}
            value={totalActiveStakings.toString()}
          />
        </Grid>
      </Grid>
      {tableItems.length > 0 && (
        <DataTable
          page={page}
          rowsPerPage={rowsPerPage}
          items={filteredList}
          columns={clubStakingColumns}
          itemsCount={stakings.stakingAccounts.length}
          onPageChange={handlePageChange}
          onSearch={() => {}}
          onRowsPerPageChange={onRowsPerPageChange}
        />
      )}
    </div>
  );
};

export default ClubStaking;
